const sortByPosition = <Item extends { position: number }>(items: Item[]) => {
  return [...items].sort((firstItem, secondItem) => firstItem.position - secondItem.position);
};

export default sortByPosition;
